import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  makeStyles,
} from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { StatusLabel } from '@shared/components/StatusLabel';
import { useProjectActivities } from '../../tasks/api';
import TaskActivityRow from './TaskActivityRow';

type TProps = {
  projectId: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

const useStyles = makeStyles({
  dialogContent: {
    maxHeight: '70vh',
    overflowY: 'auto',
  },
});

const RecentActivitiesDialog = ({ projectId, isOpen, setIsOpen }: TProps) => {
  const { data, error } = useProjectActivities(projectId, isOpen);
  const classes = useStyles();
  return (
    <Dialog open={isOpen} onOpenChange={(_, data) => setIsOpen(data.open)}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <DialogTrigger action="close">
                <Button appearance="subtle" aria-label="close" icon={<Dismiss24Regular />} />
              </DialogTrigger>
            }
          >
            Recent activities
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <StatusLabel
              data={data}
              error={error}
              loadingMessage="Loading recent activities..."
              errorMessage="Loading recent activities failed!"
              render={(activities) => (
                <div className="flex flex-col">
                  {activities.map((activity) => (
                    <TaskActivityRow
                      key={`${activity.task._id}-${activity.createdDate}-${activity.type}`}
                      projectId={projectId}
                      activity={activity}
                      multiline
                      onClick={() => setIsOpen(false)}
                    />
                  ))}
                </div>
              )}
            />
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
export default RecentActivitiesDialog;
